<template>
  <div class="tutorial bg-white">
    <search-head></search-head>
    <div class="w">
      <div class="back-btn">
        <span class="back pointer" @click="getBack">{{ $t('Home.helpCenter.TutorialDetail.Back') }}</span><span>></span><span class="current-lable">{{ $t('Home.helpCenter.TutorialDetail.Tutorial') }}</span>
      </div>
      <div class="tutorial-main f">
        <div class="tutorial-menu">
          <el-menu class="el-menu-vertical-demo" :active="defaultActive" :default-openeds="defaultOpeneds" :default-active="defaultActive">
            <el-submenu :index="index.toString()" v-for="(item,index) in categoryList" :key="index">
              <template slot="title">
                <span>{{item.className}}</span>
              </template>
              <el-menu-item :class="{'active':e.id.toString()===defaultActive}" :index="e.id.toString()" v-for="(e,i) in item.essayList" :key="i">
                <template slot="title">
                  <span class="ellipsis el-menu-item-title" @click="selectTutorialEssay(e)">{{e.title}}</span>
                </template>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
        <div class="tutorial-content">
          <h1>{{essayContent.title || ''}}</h1>
          <div class="f-c" style="margin-bottom:30px" v-if="essayContent.videoPath&&essayContent.videoPath!=='' ">
           <iframe width="908" height="511" :src="essayContent.videoPath" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <div v-html="essayContent.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AddUrlParm } from '@/util'
import _ from 'lodash'
import SearchHead from './components/SearchHead'
import API from '@/api'
export default {
  metaInfo: {
    title: 'Help Center - KakaClo',
    meta: [
      {
        name: 'description',
        content: 'KakaClo is the industry-leading apparel supply chain platform that focuses on providing customers with in stock apparel custom production and dropshipping service.'
      }
    ]
  },
  components: { SearchHead },
  data() {
    return {
      listForm: {
        pageNumber: 1,
        pageSize: 10000,
        labelName: 'Tutorial'
      },
      essayForm: {
        pageNumber: 1,
        pageSize: 4,
        labelName: 'tutorial'
      },
      categoryList: [],
      essayList: [],
      essayId: undefined,
      essayContent: {},
      defaultOpeneds: ['0', '1', '2', '3', '4', '5', '6', '7'],
      defaultActive: ''
    }
  },
  created() {
    this.listForm.classificationId = Number(this.$route.query.category_id)
    this.getEssayById()
  },
  methods: {
    getEssayById() {
      API.getEssayById(this.listForm).then(res => {
        this.categoryList = res.data
        if (this.$route.query.locate && res.data.length) {
          res.data.forEach((item) => {
            if (item.essayList && item.essayList.length) {
              item.essayList.forEach((essay) => {
                if (essay.id === Number.parseInt(this.$route.query.locate)) {
                  this.essayContent = essay
                  this.defaultActive = this.$route.query.locate
                }
              })
            }
          })
        } else {
          let selected = res.data.filter(item => { return item.className === this.$route.query.name })
          if (selected.length > 0) {
            this.essayContent = _.get(selected[0], 'essayList.0') || _.get(res, 'data.0.essayList.0') || {}
            this.defaultActive = _.get(selected[0], 'essayList.0.id') || _.get(res, 'data.0.essayList.0.id') || ''
            this.defaultActive += ''
          }
        }
      })
    },
    getEssayList() {
      API.getEssayList(this.essayForm).then(res => {
        this.essayList = res.data.list
      })
    },
    selectTutorialEssay(value) {
      window.history.replaceState(null, null, `?category_id=${this.$route.query.category_id}&name=${this.$route.query.name}&locate=${value.id}`)
      this.essayContent = value
      // this.defaultActive = value.classificationId.toString()
      this.defaultActive = value.id.toString()
      this.essayContent.content = this.getContent(value)
    },
    getContent(data) {
      let contents = data.content

      let r = RegExp(/<[img]+\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g)
      let matchres = contents.match(r)// 返回数组['<img ... />','<img ... />']
      if (matchres) {
        matchres.forEach((item, index) => {
          let len = item.length
          let _str = item.slice(0, len - 2) + ' style="max-width:100%;text-align:center;margin:0 10px;" lazy />'// 追加之后的img
          contents = contents.replace(item, _str)
        })
      }
      return contents
    },
    getBack() {
      this.$router.push('/help-center')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../css/menus.scss';
.back-btn {
  padding: 30px 0 20px;
  span {
    font-size: 16px;
    font-weight: 400;
    display: inline-block;
  }
  .back {
    color: #121e26;
    margin-right: 12px;
  }
  .current-lable {
    color: #a4a5a9;
    margin-left: 12px;
  }
}
.tutorial-main {
  padding-bottom: 100px;
}
.tutorial-menu {
  width: 30%;
  padding-right: 100px;
  h1 {
    font-size: 20px;
    font-weight: 500;
    color: #121e26;
    padding-bottom: 30px;
  }
}
.tutorial-content {
  width: 70%;
  h1 {
    font-size: 30px;
    font-weight: 600;
    text-align: center;
    color: #121e26;
    line-height: 60px;
    padding-bottom: 20px;
  }
}
.active {
  color: #99c41c !important;
}
.el-menu-item-title {
  display: inline-block;
  width: 100%;
  padding-left: 33px;
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 1000px) {
  .quest-main {
    padding-top: 50px;
  }
}
</style>
